import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { CompanyManagementUser } from "../../types/companyManagementTypes";
import { deleteCompanyManagementUserThunk, fetchCompanyManagementUsersThunk } from "../thunk/companyManagementThunk";
import { setInitalPagination } from "./utils";

export interface CompanyManagementState {
    users: CompanyManagementUser[] | [];
}

const initialState: CompanyManagementState = {
    users: [],
};

export const companyManagementSlice = createSlice({
    name: "companyManagement",
    initialState,
    reducers: {
        setUsers: (state, action: PayloadAction<CompanyManagementUser[]>) => {
            state.users = action.payload;
        },
        createUser: (state, action: PayloadAction<CompanyManagementUser>) => {
            state.users = [action.payload, ...state.users];
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchCompanyManagementUsersThunk.fulfilled, (state, action) => {
            state.users = action.payload ?? [];
            setInitalPagination(state, state.users);
        });
        builder.addCase(deleteCompanyManagementUserThunk.rejected, (_state, action) => {
            console.error("Delete failed:", action.payload);
        });
    },
});


export const {
    setUsers,
    createUser
} = companyManagementSlice.actions;

export default companyManagementSlice.reducer;
